import React from "react"
import Grid from "@material-ui/core/Grid"
import ccLogo from "@/assets/images/logo-white.png"
import { makeStyles } from "@material-ui/core/styles"
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import TwitterIcon from "@material-ui/icons/Twitter"
import YouTubeIcon from "@material-ui/icons/YouTube"
import Box from "@material-ui/core/Box"
import { Typography } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
    footerContainer: {
        color: "white",
        alignItems: "center",
        backgroundColor: "black",
        padding: theme.spacing(2, 3),
    },
    logoWrapper: {
        margin: theme.spacing(1, 0),
        justifyContent: "center",
        "& img": {
            maxHeight: "50px",
            display: "block",
        },
        [theme.breakpoints.up("lg")]: {
            justifyContent: "start",
        },
    },
    copyrightWrapper: {
        textAlign: "center",
        margin: theme.spacing(1, 0),
        lineHeight: 1,
    },
    socialMediaWrapper: {
        margin: theme.spacing(1, 0),
        justifyContent: "center",
        [theme.breakpoints.up("lg")]: {
            justifyContent: "flex-end",
        },
    },
    icon: {
        width: "30px",
        height: "30px",
    },
}))

const FooterShared = () => {
    const classes = useStyles()

    return (
        <Grid id="footer" container className={classes.footerContainer}>
            <Grid item xs={12} lg={4}>
                <Box display="flex" className={classes.logoWrapper}>
                    <a href={`${process.env.CC_MAIN_SITE}`}>
                        <img src={ccLogo} alt="sparca-logo" />
                    </a>
                </Box>
            </Grid>
            <Grid item xs={12} lg={4}>
                <Box className={classes.copyrightWrapper}>
                    <Typography>Copyright © {new Date().getFullYear()} Customer Crunch</Typography>
                </Box>
            </Grid>
            <Grid item xs={12} lg={4}>
                <Box display="flex" className={classes.socialMediaWrapper}>
                    <Box ml={1} mr={1}>
                        <a href="https://twitter.com/customercrunch">
                            <TwitterIcon className={classes.icon} />
                        </a>
                    </Box>
                    <Box ml={1} mr={1}>
                        <a href="https://www.linkedin.com/company/customer-crunch/">
                            <LinkedInIcon className={classes.icon} />
                        </a>
                    </Box>
                    <Box ml={1} mr={1}>
                        <a href="https://www.youtube.com/channel/UCMn8qak14cpOS_xv753H1Iw">
                            <YouTubeIcon className={classes.icon} />
                        </a>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    )
}

export default FooterShared
